// src/components/practice/tasks/writing/layouts/OsdB2EssayLayout.jsx
import React from 'react';
import { marked } from 'marked';
import { parseOsdB2EssayContent } from '../parsers/osdB2EssayParser.js';

const OsdB2EssayLayout = ({ scenario }) => {
    const parsed = parseOsdB2EssayContent(scenario);

    if (!parsed) return null;

    return (
        <div className="mb-6">
            {/* Intro text with topic */}
            {parsed.introText && (
                <p className="text-gray-800 mb-4"
                   dangerouslySetInnerHTML={{ __html: marked.parse(parsed.introText) }} />
            )}

            {/* Opinion/Statement boxes in a grid */}
            {parsed.statements.length > 0 && (
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-6">
                    {parsed.statements.map((statement, idx) => {
                        // Check if statement has a header (Format B with colon)
                        const hasHeader = statement.includes(':');
                        const parts = hasHeader ? statement.split(':') : [statement];
                        const header = hasHeader ? parts[0] : '';
                        const content = hasHeader ? parts.slice(1).join(':').trim() : statement;

                        return (
                            <div
                                key={idx}
                                className="border-2 border-dashed border-gray-400 p-4 bg-gray-50 min-h-[120px] flex flex-col justify-center"
                            >
                                {hasHeader && (
                                    <p className="font-bold text-gray-900 text-base mb-2">
                                        {header}:
                                    </p>
                                )}
                                <p className="text-gray-700 italic text-sm leading-relaxed">
                                    {content}
                                </p>
                            </div>
                        );
                    })}
                </div>
            )}

            {/* Instruction text */}
            {parsed.instructionIntro && (
                <p className="text-gray-800 mb-3">
                    {parsed.instructionIntro}
                </p>
            )}

            {/* Numbered points */}
            {parsed.instructions && (
                <div className="text-gray-800 whitespace-pre-line">
                    {parsed.instructions}
                </div>
            )}
        </div>
    );
};

export default OsdB2EssayLayout;